import React from 'react'
import classnames from 'classnames'

import { list, listItem, listIcon, listText } from './InfoList.module.scss'

const InfoList = ({
  items,
  itemType,
  columns,
  background,
  className,
  ...props
}) => {
  return (
    <ul
      className={classnames(
        list,
        `columns-${columns}`,
        className,
        background && 'vs-background'
      )}
      {...props}
    >
      {items.map((item, idx) => {
        const { text, icon } = item

        return (
          <li key={idx} className={classnames(listItem, itemType)}>
            <div className={listIcon}>
              <img
                src={icon.sourceUrl}
                alt={icon.altText}
                width={icon.mediaDetails.width}
                height={icon.mediaDetails.height}
                loading={'lazy'}
              />
            </div>
            <div className={listText}>{text}</div>
          </li>
        )
      })}
    </ul>
  )
}

export default InfoList
